import { useState, useEffect } from 'react';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { RxCross2 } from "react-icons/rx";
import {
    FacebookIcon,
    FacebookShareButton,
    LinkedinIcon,
    TelegramIcon,
    TwitterIcon,
    WhatsappIcon,
    TwitterShareButton,
    WhatsappShareButton,
    LinkedinShareButton,
    TelegramShareButton,
} from "react-share";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useDispatch } from "react-redux";
import { showSuccess, showError } from "../../stores/slices/commonSlice";

export default function SocialShare({ open = false, handleClose, eventLink }) {
    const [shareableLink, setShareableLink] = useState(null);
    const dispatch = useDispatch();
    
    useEffect(() => {
        if(eventLink){
            setShareableLink(`https://${eventLink}.apsession.com`);
        }
        else{
            setShareableLink(window.location.href);
        }
    }, [eventLink]);

    const handleCopyLink = () => {
        if (!navigator.clipboard) {
            console.error("Clipboard API not available");
            dispatch(showError("Clipboard not supported over http."));
            return;
        }
        navigator.clipboard
            .writeText(shareableLink)
            .then(() => {
                dispatch(showSuccess("Link copied to clipboard!"));
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
                dispatch(showError("Failed to copy link."));
            });
    };

    return (
        <>
            <Dialog className="onlysocial" open={open} onClose={handleClose}>
                <DialogContent className="share-box" data-aos="zoom-in">
                    <div
                        className="mb-3"
                        style={{
                            borderBottom: "2px solid #f8f7fa",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingBottom: "15px",
                        }}
                    >
                        <h6
                            style={{
                                margin: "0 auto",
                                flex: "1",
                                textAlign: "center",
                            }}
                        >
                            Share with friends
                        </h6>
                        <RxCross2 onClick={()=>handleClose()} style={{ marginLeft: "auto" }} />
                    </div>

                    <div className="social-icon-box">
                        <FacebookShareButton url={shareableLink}>
                            <FacebookIcon
                                size={40}
                                round={true}
                                bgStyle={{ fill: "#f8f7fa" }}
                                iconFillColor="#000"
                                href="rhrjejgj"
                            />
                        </FacebookShareButton>
                        <TwitterShareButton url={shareableLink}>
                            <TwitterIcon
                                size={40}
                                round={true}
                                bgStyle={{ fill: "#fff" }}
                                iconFillColor="#000"
                            />
                        </TwitterShareButton>
                        <WhatsappShareButton url={shareableLink}>
                            <WhatsappIcon
                                size={40}
                                round={true}
                                bgStyle={{ fill: "#fff" }}
                                iconFillColor="#000"
                            />
                        </WhatsappShareButton>
                        <LinkedinShareButton url={shareableLink}>
                            <LinkedinIcon
                                size={40}
                                round={true}
                                bgStyle={{ fill: "#fff" }}
                                iconFillColor="#000"
                            />
                        </LinkedinShareButton>
                        <TelegramShareButton url={shareableLink}>
                            <TelegramIcon
                                size={40}
                                round={true}
                                bgStyle={{ fill: "#fff" }}
                                iconFillColor="#000"
                            />
                        </TelegramShareButton>
                    </div>

                    <div>
                        <div
                            className="d-flex text-center"
                            style={{ marginBottom: "20px" }}
                        >
                            <div
                                style={{
                                    border: "1px solid grey",
                                    padding: "5px 10px",
                                    margin: "0px auto",
                                }}
                            >
                                <p
                                    style={{
                                        textAlign: "left",
                                        fontSize: "12px",
                                        marginBottom: "0px",
                                    }}
                                >
                                    Event Url
                                </p>
                                <div className="row">
                                    <div className="col-md-11 col-10">
                                <p
                                    style={{
                                        fontSize: "14px",
                                        marginBottom: "0px",
                                    }}
                                >  </p>
                                 {shareableLink}{" "}
                                </div>
                                <div className="col-md-1 col-2">
                                   
                                    <ContentCopyIcon
                                       
                                        onClick={() => {
                                            handleCopyLink();
                                        }}
                                    />{" "}
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
}
